var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"style-number-image"},[(_vm.error)?[_vm._v("\n    /\n  ")]:[(_vm.imageUrl)?_c('el-image',{attrs:{"src":_vm.imageUrl,"preview-src-list":[_vm.imageUrl],"fit":"contain"},on:{"error":_vm.handleError}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }